import { ShortcutItem } from '@/Interfaces/ShortcutItem.interface';
import { DATE_PICKER_SHORTCUTS, footTrafficShortcuts } from '@/constants/date';
import { Moment } from 'moment';

/** `Last 7 Days` and `Last 30 days` shortcuts include current day */
export const getShortcutItemsInclusive = (): ShortcutItem[] => [
  DATE_PICKER_SHORTCUTS.TODAY,
  DATE_PICKER_SHORTCUTS.YESTERDAY,
  DATE_PICKER_SHORTCUTS.LAST_7_DAYS_INCLUSIVE,
  DATE_PICKER_SHORTCUTS.LAST_30_DAYS_INCLUSIVE,
  DATE_PICKER_SHORTCUTS.THIS_MONTH,
  DATE_PICKER_SHORTCUTS.LAST_MONTH,
  DATE_PICKER_SHORTCUTS.THIS_YEAR,
  DATE_PICKER_SHORTCUTS.ALL_TIME,
  DATE_PICKER_SHORTCUTS.CUSTOM_RANGE,
];

/** `Last 7 Days` and `Last 30 days` shortcuts exclude current day */
export const getShortcutItemsExclusive = (): ShortcutItem[] => [
  DATE_PICKER_SHORTCUTS.TODAY,
  DATE_PICKER_SHORTCUTS.YESTERDAY,
  DATE_PICKER_SHORTCUTS.LAST_7_DAYS,
  DATE_PICKER_SHORTCUTS.LAST_30_DAYS,
  DATE_PICKER_SHORTCUTS.THIS_MONTH,
  DATE_PICKER_SHORTCUTS.LAST_MONTH,
  DATE_PICKER_SHORTCUTS.THIS_YEAR,
  DATE_PICKER_SHORTCUTS.ALL_TIME,
  DATE_PICKER_SHORTCUTS.CUSTOM_RANGE,
];

export const getFootTrafficShortcutItems = (maxDate: Moment) => Object.values(footTrafficShortcuts(maxDate));
